import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from "@mui/material";
import { faBasketShopping, faBoxesStacked } from '@fortawesome/free-solid-svg-icons';
import { TopBar } from "../common/TopBar";
import ProductsService from "../../services/productsService";
import { Card, Col, Row, Button, Container, ButtonGroup, Spinner } from "react-bootstrap";
import { ArrowReturnLeft } from 'react-bootstrap-icons';
import { Header } from "../common/Header";
import { useCart } from "../../context/CartContext";
import { ItemDetailSkeleton } from "../common/Skeletons";
import { EmptyState } from "../common/EmptyState";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";

export const ShopItemPage = (props) => {
    let { id } = useParams();

    const { addItem: addItemToCart } = useCart();

    const [item, setItem] = useState();
    const service = ProductsService();
    const [itemImage, setItemImage] = useState(null);
    const [quantity, setQuantity] = useState(1);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);
    const [itemLoaded, setItemLoaded] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [error, setError] = useState(null);

    const [state, setState] = useState({
        isValid: true,
        stock: "1"
    });

    const navigate = useNavigate();

    const handleCloseSuccessDialog = () => {
        setShowSuccessDialog(false);
        onBack();
    };

    const onBack = () => {
        navigate("/shop", { replace: true });
    };

    useEffect(() => {
        const encodedData = (id);
        service.getProduct(encodedData).then(stitem => {
        
        console.log('Product data:', stitem);
        setItem(stitem);
    
        const newStock = stitem.inventory > 20 ? ">20" : stitem.inventory;
        let a = Object.assign({}, state, { stock: newStock });

        setState(a);
        
        setItemLoaded(true);
        
        // Try multiple possible property names for product ID
        const productId = stitem.no || stitem.No || stitem.id || stitem.Id || stitem.itemNo || stitem.ItemNo;
        console.log('Product ID for image:', productId);
        
        if (productId) {
            service.getProductImages(productId).then(image => {
                console.log('Image loaded successfully');
                setItemImage(image);
                setImageLoaded(true);
            }).catch(error => {
                console.error('Error loading image:', error);
                setImageLoaded(true); // Set to true to stop spinner even on error
            });
        } else {
            console.error('No valid product ID found');
            setImageLoaded(true);
        }
        
    }).catch(error => {
        console.error('Error loading product:', error);
        setItemLoaded(true);
    });
}, [id]);

    const validateNumberField = (quantity) => {
        return !(quantity.length == 0 || quantity < 1 || quantity > item.availableInventory);
    }

    const changeQuantity = (e) => {
        const { value } = e.target;
        const isValid = validateNumberField(value);
        setState({
            isValid
        });
        quantity = value;
    }

    const toCamelCase = (str) => {
        if (str) {
            const a = str.split(' ').map((item, index) => {
                return item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
            });

            let result = a.join(' ');
            if (result.trim() === "") {
                result = "<No Brand>";
            }

            return result;
        }
    };

    

    const onBuyHandler = async () => {
        console.log('onBuyHandler', item.no, quantity);
      
        try {
          await addItemToCart(item.no, quantity);
          setShowSuccessDialog(true);
        } catch (error) {
          console.error('Error adding item to cart:', error);
          setError(error);
        }
      };

    return (
        <>
        <Header />
        <TopBar />
            <Container className="py-4">
                <Row className="mb-4">
                    <Col xs={12} md={3}>
                        <Button 
                            variant="outline-dark" 
                            size="lg"
                            className="product-page-back-btn"
                            onClick={onBack}>
                            <ArrowReturnLeft className="me-2" /> Back
                        </Button>
                    </Col>
                    <Col xs={12} md={6} className="text-center">
                        <h2 className="product-page-title">Product Details</h2>
                    </Col>
                    <Col xs={12} md={3}></Col>
                </Row>

                {!itemLoaded && (
                    <Box sx={{ px: 2 }}>
                        <ItemDetailSkeleton />
                    </Box>
                )}

                {itemLoaded && !item && (
                    <EmptyState
                        icon={<SearchOffOutlinedIcon />}
                        title="Product not found"
                        description="This product is no longer available or the link is invalid. Try searching for a similar product."
                        action={
                            <Button variant="primary" onClick={onBack}>
                                Back to shop
                            </Button>
                        }
                    />
                )}

                {itemLoaded && item && (
                    <Row className="justify-content-center">
                        <Col xs={12} lg={11} xl={10}>
                            <Card className="product-detail-card">
                                <Card.Body className="p-4">
                                    <Row>
                                        {/* Left Column - Image */}
                                        <Col xs={12} md={5} lg={5} className="mb-4 mb-md-0">
                                            <div className="product-detail-img-wrap-column">
                                                {imageLoaded ? (
                                                    <img 
                                                        className="product-detail-img" 
                                                        src={`data:image/jpeg;base64,${itemImage}`} 
                                                        alt={item.description}
                                                        onError={(e) => {
                                                            console.error('Image failed to load');
                                                            e.target.style.display = 'none';
                                                        }}
                                                    />
                                                ) : (
                                                    <div className="text-center py-5">
                                                        <Spinner animation="border" variant="dark" />
                                                    </div>
                                                )}
                                            </div>
                                        </Col>

                                        {/* Right Column - Information */}
                                        <Col xs={12} md={7} lg={7}>
                                            {/* Product Header */}
                                            <div className="product-detail-header-column mb-4">
                                                {item.category && (
                                                    <div className="product-detail-brand">
                                                        {item.category}
                                                    </div>
                                                )}
                                                <h3 className="product-detail-title">
                                                    {toCamelCase(item.description || '')}
                                                </h3>
                                                <p className="product-detail-sku">
                                                    SKU: {item.no || ''}
                                                </p>
                                            </div>

                                            {/* Product Info */}
                                            <Row className="product-detail-info-column mb-4">
                                                <Col xs={6}>
                                                    <div className="info-label">Price</div>
                                                    <div className="info-value">
                                                        € {item.price?.toFixed(2) || '0.00'}
                                                    </div>
                                                </Col>
                                                <Col xs={6}>
                                                    <div className="info-label">Stock</div>
                                                    <div className="info-value">
                                                        <FontAwesomeIcon icon={faBoxesStacked} className="me-2" />
                                                        {item.inventory || 0}
                                                    </div>
                                                </Col>
                                            </Row>

                                            {/* Complete Specifications */}
                                            <div className="product-specs-column mb-4">
                                                <h5 className="specs-title">Product Details</h5>
                                                <Row>
                                                    {item.category && (
                                                        <Col xs={12} md={6}>
                                                            <div className="spec-item">
                                                                <span className="spec-label">Category:</span>
                                                                <span className="spec-value">{item.category}</span>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {item.brand && item.brand.trim() && (
                                                        <Col xs={12} md={6}>
                                                            <div className="spec-item">
                                                                <span className="spec-label">Brand:</span>
                                                                <span className="spec-value">{item.brand}</span>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {item.diameter && item.diameter !== '_x0020_' && (
                                                        <Col xs={12} md={6}>
                                                            <div className="spec-item">
                                                                <span className="spec-label">Diameter:</span>
                                                                <span className="spec-value">
                                                                    {item.diameter.replace(/_x002E_/g, '.').replace(/_x0020_/g, ' ').trim()}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {item.radius && item.radius !== '_x0020_' && (
                                                        <Col xs={12} md={6}>
                                                            <div className="spec-item">
                                                                <span className="spec-label">Radius:</span>
                                                                <span className="spec-value">
                                                                    {item.radius.replace(/_x0020_/g, ' ').trim()}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    )}
                                                    {item.wall && item.wall !== '_x0020_' && (
                                                        <Col xs={12} md={6}>
                                                            <div className="spec-item">
                                                                <span className="spec-label">Wall:</span>
                                                                <span className="spec-value">
                                                                    {item.wall.replace(/_x0020_/g, ' ').trim()}
                                                                </span>
                                                            </div>
                                                        </Col>
                                                    )}
                                                </Row>
                                            </div>

                                            {/* Purchase Actions */}
                                            <div className="product-detail-actions-column">
                                                <div className="quantity-selector">
                                                    <label className="quantity-label">Quantity</label>
                                                    <input 
                                                        type="number" 
                                                        onChange={changeQuantity}
                                                        min={1} 
                                                        max={item.availableInventory}
                                                        defaultValue={quantity}
                                                        className="product-quantity-input-large"
                                                    />
                                                </div>
                                                <Button 
                                                    variant="dark" 
                                                    size="lg"
                                                    className="buy-button"
                                                    disabled={!state.isValid} 
                                                    onClick={onBuyHandler}>
                                                    <FontAwesomeIcon icon={faBasketShopping} className="me-2" />
                                                    ADD TO BASKET
                                                </Button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                )}

                <Dialog open={showSuccessDialog} onClose={handleCloseSuccessDialog}>
                    <DialogTitle>Success</DialogTitle>
                    <DialogContent>
                        <DialogContentText>The item has been added to the cart.</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseSuccessDialog}>OK</Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </>
    );
};